<!-- chat-floating.component.html -->

<!-- Botón flotante -->
<div class="chat-fab" (click)="toggleChat()" [class.active]="isOpen">
    <i *ngIf="!isOpen" class="bi bi-chat-dots-fill"></i>
    <i *ngIf="isOpen" class="bi bi-x-lg"></i>
  </div>
  
  <!-- Ventana de chat -->
  <div class="chat-window" [class.open]="isOpen">
    
    <!-- Header -->
    <div class="chat-header">
      <div class="header-left">
        <i class="bi bi-robot"></i>
        <div>
          <strong>Asistente IA</strong>
          <span>● En línea</span>
        </div>
      </div>
      <button (click)="toggleChat()" class="close-btn">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  
    <!-- Mensajes -->
    <div class="chat-messages" #messagesContainer>
      <!-- Estado vacío -->
      <div *ngIf="messages.length === 0" class="empty-state">
        <i class="bi bi-chat-square-text"></i>
        <p>¡Hola! Soy tu asistente virtual. ¿En qué puedo ayudarte?</p>
        <div class="quick-suggestions">
          <button (click)="sendQuickSuggestion('¿Cómo funciona la plataforma?')">¿Cómo funciona?</button>
          <button (click)="sendQuickSuggestion('¿Qué servicios ofrecen?')">Servicios</button>
          <button (click)="sendQuickSuggestion('Necesito ayuda con mi reserva')">Ayuda con reserva</button>
        </div>
      </div>
  
      <!-- Mensajes -->
      <div *ngFor="let msg of messages" class="message" [class.user]="msg.sender === 'user'">
        <div class="avatar">
          <i *ngIf="msg.sender === 'bot'" class="bi bi-robot"></i>
          <i *ngIf="msg.sender === 'user'" class="bi bi-person"></i>
        </div>
        <div class="bubble">
          {{ msg.text }}
          <div *ngIf="msg.isLoading" class="typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Input -->
    <div class="chat-input">
      <input
        [(ngModel)]="newMessage"
        (keydown.enter)="sendMessage()"
        placeholder="Escribe tu mensaje..."
        [disabled]="isLoading"
      />
      <button (click)="sendMessage()" [disabled]="!newMessage.trim() || isLoading">
        <i class="bi bi-send-fill"></i>
      </button>
    </div>
  </div>